define("settings/controllers/subscription/billing/edit", ["exports", "ember-concurrency/async-arrow-runtime", "@ember/controller", "@ember/object", "@ember/service", "@ember/utils", "@glimmer/tracking", "ember-concurrency", "lodash"], function (_exports, _asyncArrowRuntime, _controller, _object, _service, _utils, _tracking, _emberConcurrency, _lodash) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"@ember/controller",0,"@ember/object",0,"@ember/service",0,"@ember/utils",0,"@glimmer/tracking",0,"ember-concurrency",0,"lodash"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  let BillingEditController = _exports.default = (_class = class BillingEditController extends _controller.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "address", _descriptor, this);
      _initializerDefineProperty(this, "alerts", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
      _initializerDefineProperty(this, "settings", _descriptor4, this);
      _initializerDefineProperty(this, "router", _descriptor5, this);
      _initializerDefineProperty(this, "hasAttemptedSave", _descriptor6, this);
      _initializerDefineProperty(this, "showUnconfirmedForm", _descriptor7, this);
      _initializerDefineProperty(this, "selectedAddressOption", _descriptor8, this);
      _initializerDefineProperty(this, "isShowingSuggestedForm", _descriptor9, this);
      _defineProperty(this, "confirmRouteChange", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (transition) {
          if (this.hasDirtyAttributes) {
            transition.abort();
            yield this.settings.confirmClose(this.hasDirtyAttributes);
            this.resetForm();
            transition.retry();
          }
        }
      }), null, "confirmRouteChange", "drop"));
      _defineProperty(this, "handleClose", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          yield this.settings.confirmClose(this.hasDirtyAttributes);
          this.resetForm();
          this.router.transitionTo('account.subscription.billing');
        }
      }), null, "handleClose", "drop"));
      _defineProperty(this, "handleSubmit", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (currentAccount, addressFields) {
          try {
            this.hasAttemptedSave = true;
            const addressToSave = this.selectedAddressOption === 'suggested' ? this.address.suggestedAddressFields : addressFields;
            if (this.address.addressCollectionEnabledInSettings) {
              this.address.trackClickedSave(addressFields, 'billing');
              const isAddressValid = yield this.address.validateAddress.perform(addressFields);
              if (!this.showUnconfirmedForm && !isAddressValid) {
                this.address.trackViewedValidationError(addressFields, 'billing');
                this.showUnconfirmedForm = true;
                this.selectedAddressOption = this.hasAddressSuggestions ? 'suggested' : 'entered';
                if (this.hasAddressSuggestions) {
                  this.isShowingSuggestedForm = true;
                  this.alerts.warning(this.intl.t('alerts.account.address.warning.suggestions.description'), {
                    title: this.intl.t('alerts.account.address.warning.suggestions.title'),
                    sticky: false
                  });
                } else {
                  this.alerts.warning(this.intl.t('alerts.account.address.warning.no_suggestions.description'), {
                    title: this.intl.t('alerts.account.address.warning.no_suggestions.title'),
                    sticky: false
                  });
                }
                return;
              }
              yield this.address.save.perform(addressToSave);
              this.address.trackSavedSuccessfully(addressFields, 'billing');
            }
            const {
              response
            } = yield this.settings.submitForm.perform(currentAccount.save(), 'account.subscription.billing.edit');
            this.alerts.success(this.intl.t('alerts.account.subscription.billing.success.message'), {
              title: this.intl.t('alerts.account.subscription.billing.success.title')
            });
            yield this.handleClose.perform(response, addressToSave);
          } catch ({
            alert
          }) {
            if (alert) {
              this.address.trackViewedServerError(addressFields, 'billing');
              this.alerts.add(alert);
            }
          }
        }
      }), null, "handleSubmit", "drop"));
    }
    get isEditDisabled() {
      return this.address.validateAddress.isRunning || this.address.save.isRunning || this.settings.submitForm.isRunning;
    }
    get isSaveDisabled() {
      return this.hasAttemptedSave && !this.address.hasRequiredFields(this.addressFields);
    }
    get showAddress() {
      return this.address.addressCollectionEnabledInSettings;
    }
    get addressFields() {
      return this.address.unsavedAddressFields;
    }
    get hasAddressSuggestions() {
      return (0, _utils.isPresent)(this.address.suggestedChanges);
    }
    get hasDirtyAttributes() {
      const hasDirtyAddressFields = this.address.addressCollectionEnabledInSettings && !(0, _lodash.isEqual)(this.addressFields, this.address.savedAddressFields);
      return this.currentAccount?.hasDirtyAttributes || hasDirtyAddressFields;
    }
    handleSuggestedAddressChange(address) {
      this.selectedAddressOption = address;
    }
    setEditingAddress() {
      this.showUnconfirmedForm = false;
    }
    setSelectedCountry(country) {
      this.address.setSelectedCountry(country);
    }
    setSuggestion(addressField, suggestedValue) {
      this.address.setSuggestion(addressField, suggestedValue);
    }
    resetForm() {
      this.currentAccount?.rollbackAttributes();
      this.address.resetForm();
      this.hasAttemptedSave = false;
      this.showUnconfirmedForm = false;
      this.selectedAddress = undefined;
      this.isShowingSuggestedForm = false;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "address", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "settings", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "hasAttemptedSave", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "showUnconfirmedForm", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "selectedAddressOption", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "isShowingSuggestedForm", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "handleSuggestedAddressChange", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleSuggestedAddressChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setEditingAddress", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setEditingAddress"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setSelectedCountry", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setSelectedCountry"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setSuggestion", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setSuggestion"), _class.prototype)), _class);
});